import { clientLogos } from "@/data/clientLogos";

const Row = ({ ariaHidden }) => (
    <div className="flex shrink-0 items-center gap-6 pr-6" aria-hidden={ariaHidden}>
        {clientLogos.map((c) => (
            <div
                key={(ariaHidden ? "b-" : "a-") + c.file}
                data-testid={ariaHidden ? undefined : `client-logo-${c.file}`}
                className="flex h-20 w-36 flex-none items-center justify-center rounded-xl border border-white/8 bg-white/[0.04] px-2.5"
                title={c.name}
            >
                <img
                    src={`/logos/${c.file}.png`}
                    alt={`${c.name} — client of Ragi Media`}
                    loading="lazy"
                    className="max-h-14 w-auto max-w-[88%] object-contain opacity-80 grayscale transition duration-300 hover:opacity-100 hover:grayscale-0 md:max-h-16"
                />
            </div>
        ))}
    </div>
);

// Infinite horizontal marquee of client logos.
export default function ClientLogos() {
    return (
        <div
            data-testid="client-logos-marquee"
            className="group relative overflow-hidden"
            style={{
                maskImage:
                    "linear-gradient(to right, transparent, black 6%, black 94%, transparent)",
                WebkitMaskImage:
                    "linear-gradient(to right, transparent, black 6%, black 94%, transparent)",
            }}
        >
            <div className="flex w-max animate-marquee group-hover:[animation-play-state:paused]">
                <Row />
                <Row ariaHidden />
            </div>
        </div>
    );
}
